(function ($) {
  // Responsive functionality
  const conditionSearchStatic = document.querySelector('.conditions-and-treatments-tool--static');
  if (conditionSearchStatic != null) {
    isCondensed();
    window.addEventListener('resize', isCondensed);
    const newDiv = document.createElement('div');
    conditionSearchStatic.before(newDiv);
    newDiv.setAttribute('id', 'scroll-ref');
    const stickyHeight = conditionSearchStatic.offsetHeight + 24;
    const stickyOffset = conditionSearchStatic.offsetTop;
    let lastScrollY = window.scrollY;
    window.addEventListener('scroll', () => handleScroll(stickyHeight));
  }
  function isCondensed() {
    if (conditionSearchStatic && window.innerWidth < 900) {
      conditionSearchStatic.classList.add('is-condensed');
    } else {
      conditionSearchStatic.classList.remove('is-condensed');
    }
  }
  function normalizeString(str) {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }
  function handleScroll(height) {
    const scrollRef = document.querySelector('#scroll-ref');
    const scrollRefRect = scrollRef.getBoundingClientRect();
    const conditionSearchStaticRect = conditionSearchStatic.getBoundingClientRect();
    const currentScrollY = window.scrollY;

    if (conditionSearchStaticRect.bottom <= 0 && currentScrollY > lastScrollY) {
      conditionSearchStatic.classList.add('is-sticky', 'is-condensed');
      scrollRef.style.height = height + 'px';
    }

    if (
      conditionSearchStatic.classList.contains('is-sticky') &&
      scrollRefRect.bottom <= 50 &&
      currentScrollY < lastScrollY
    ) {
      conditionSearchStatic.classList.remove('is-sticky', 'is-condensed');
      scrollRef.style.height = '0px';
    }

    lastScrollY = currentScrollY;
  }

  // Search form functionality
  const conditionSearchForm = document.querySelector(".condition-search-form");
  if (conditionSearchForm != null) {
    const conditionSearchInput = conditionSearchForm.querySelector("#condition-search");
    const conditionDropdown = document.querySelector(".condition-search-dropdown");
    const dropdownItems = document.querySelectorAll(".condition-search-dropdown ul li");

    // Event listeners for search form
    conditionSearchForm.addEventListener("submit", function(e) {
      e.preventDefault();
      conditionSearchInput.blur();
      $(".condition-search-dropdown").hide();
      if (conditionSearchInput.value.trim() !== "") {
        const listingUrl = conditionSearchForm.dataset.listingUrl;
        let isExactMatch = false;
        dropdownItems.forEach((item) => {
          if (normalizeString(item.dataset.text) === normalizeString(conditionSearchInput.value)) {
            isExactMatch = true;
          }
        });
        if (isExactMatch) {
          window.location.href = listingUrl + "?ctsearch=" + encodeURIComponent(conditionSearchInput.value) + "&ctcategory=true";
        } else {
          window.location.href = listingUrl + "?ctsearch=" + encodeURIComponent(conditionSearchInput.value);
        }
      }
    }); 
    conditionSearchInput.addEventListener("blur", function() {
      setTimeout(function() {
        $(".condition-search-dropdown").hide();
      }, 200);
    });
    conditionSearchInput.addEventListener("keyup", function(e) {
      handleInput(e.target.value);
    });
    dropdownItems.forEach((item) => {   
      const button = item.querySelector("button.dropdown-category");
      const link = item.querySelector("a");
      item.dataset.text = button ? button.textContent : (link ? link.textContent : "");
      item.addEventListener("click", function(e) {
        if (button && e.target === button) {
          e.preventDefault();
          const category = button.textContent.trim();
          conditionSearchInput.value = category;
          handleInput(category);
          $(`#${category.replaceAll(' ', '-')}-conditions`).show();
          $(`#${category.replaceAll(' ', '-')}-conditions .conditions-and-treatments-item`).show();
          $('html,body').animate({ scrollTop: $(`#${category.replaceAll(' ', '-')}`).offset().top - 100 }, 500);
        }
      });
    });

    // Handle url parameters
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("ctsearch") && !urlParams.has("ctcategory")) {
      const searchValue = decodeURIComponent(urlParams.get("ctsearch"));
      const conditionSearchHeight = document.querySelector('.conditions-and-treatments-tool--static');
      const searchOffset = conditionSearchHeight.offsetHeight;
      conditionSearchInput.value = searchValue;
      handleInput(searchValue);
      $(".condition-search-dropdown").hide();
      $('html,body').animate({ scrollTop: $('.conditions-and-treatments-listing').offset().top - searchOffset }, 500);
    } else if (urlParams.has("ctcategory")) {
      const categoryValue = decodeURIComponent(urlParams.get("ctsearch"));
      conditionSearchInput.value = categoryValue;
      handleInput(categoryValue);
      $(".condition-search-dropdown").hide();

      // Use normalizeString for accent/case-insensitive matching
      const normalizedTargetId = normalizeString(categoryValue.replaceAll(' ', '-') + '-conditions');
      console.log('normalizedTargetId', normalizedTargetId);
      let targetElem = null;
      document.querySelectorAll('[id$="-conditions"]').forEach(function(elem) {
        console.log('Elements', normalizeString(elem.id));
        if (normalizeString(elem.id) === normalizedTargetId) {
          targetElem = elem;
        }
      });
      if (targetElem) {
        $(targetElem).show();
        $(targetElem).find('.conditions-and-treatments-item').show();
        const mainSectionId = targetElem.id.replace(/-conditions$/, '');
        const normalizedMainSectionId = normalizeString(mainSectionId);
        const mainSectionElem = Array.from(document.querySelectorAll('[id]')).find(e => normalizeString(e.id) === normalizedMainSectionId);
        if (mainSectionElem) {
          $('html,body').animate({ scrollTop: $(mainSectionElem).offset().top - 100 }, 500);
        }
      }
    }

    // Handle input changes
    function handleInput(input) {
      if (input == "") {
        resetSearch();
      } else {
        $(".condition-search-dropdown").show();
        filterDropdown(input);
        let clearBtn = document.querySelector(".clear-condition-search");
        if (clearBtn) {
          clearBtn.style.opacity = "1";
        }
      }
    }

    // Filter dropdown items based on search input
    function filterDropdown(input) {
      dropdownItems.forEach((item) => {
        const normalizedItemText = normalizeString(item.textContent);
        const normalizedInput = normalizeString(input);
        if (normalizedItemText.includes(normalizedInput)) {
          item.classList.remove("hidden");
          const startMatch = normalizedItemText.indexOf(normalizedInput);
          const endMatch = startMatch + normalizedInput.length;
          const originalText = item.dataset.text;

          // Map normalized match indices back to original string
          let oStart = null, oEnd = null, nIdx = 0, oIdx = 0;
          while (oIdx < originalText.length && nIdx <= endMatch) {
            // Skip over characters in originalText that normalize to empty (e.g., accents)
            const nChar = normalizeString(originalText[oIdx]);
            if (nChar.length === 0) {
              oIdx++;
              continue;
            }
            if (nIdx === startMatch && oStart === null) oStart = oIdx;
            if (nIdx === endMatch && oEnd === null) oEnd = oIdx;
            oIdx++;
            nIdx++;
          }
          // If match goes to end, set oEnd to end of string
          if (oEnd === null && oStart !== null) oEnd = originalText.length;

          const linkEl = item.querySelector("a");
          const buttonEl = item.querySelector("button.dropdown-category");
          if (linkEl) {
            if (oStart !== null && oEnd !== null) {
              linkEl.innerHTML = originalText.slice(0, oStart) + `<span>` + originalText.slice(oStart, oEnd) + `</span>` + originalText.slice(oEnd);
            } else {
              linkEl.innerHTML = originalText;
            }
          }
          if (buttonEl) {
            if (oStart !== null && oEnd !== null) {
              buttonEl.innerHTML = originalText.slice(0, oStart) + `<span>` + originalText.slice(oStart, oEnd) + `</span>` + originalText.slice(oEnd);
            } else {
              buttonEl.innerHTML = originalText;
            }
          }
        } else {
          item.classList.add("hidden");
        }
      });

      // Check and handle no results
      let count = 0;
      dropdownItems.forEach((item) => {
        if (!item.classList.contains("hidden")) {
          count++;
        }
      });
      if (count === 0) {
        const noResults = conditionDropdown.querySelector(".no-results");
        noResults.querySelector("span").textContent = input;
        //noResults.classList.remove("hidden");
        conditionDropdown.style.display = "none";
        $(".conditions-and-treatments-listing__intro").show();
        $(".conditions-and-treatments-listing__items").show();
        $(".conditions-and-treatments-item").show();
        const noResultsListing = document.querySelector(".no-results-listing");
        if (noResultsListing !== null) {
          noResultsListing.querySelector("span").textContent = input;
          noResultsListing.classList.remove("hidden");
        }
      } else {
        conditionDropdown.querySelector(".no-results").classList.add("hidden");
        //document.querySelector(".no-results-listing").classList.add("hidden");
        const noResultsListing = document.querySelector(".no-results-listing");
        if (noResultsListing !== null) {
          noResultsListing.classList.add("hidden");
        }
        filterCategories(input);
      }
    }

    // Filter categories based on search input
    function filterCategories(input) {
      const items = document.querySelectorAll(".conditions-and-treatments-item");
      const normalizedInput = normalizeString(input);
      items.forEach((item) => {
        const h3 = item.querySelector("h3");
        if (h3 && normalizeString(h3.textContent).includes(normalizedInput)) {
          item.classList.remove("hidden");
          item.style.display = "block";
        } else {
          item.classList.add("hidden");
          item.style.display = "none";
        }
      });
      var itemGroups = document.querySelectorAll(".conditions-and-treatments-listing__items");
      itemGroups.forEach((group) => {
        const prevId = group.previousElementSibling && group.previousElementSibling.id ? normalizeString(group.previousElementSibling.id) : "";
        if (group.querySelectorAll(".conditions-and-treatments-item:not(.hidden)").length === 0
            && !prevId.includes(normalizeString(input.replaceAll(' ', '-')))) {
          group.previousElementSibling.style.display = "none";
        } else {
          group.previousElementSibling.style.display = "block";
        }
      });
    }

    // Reset search functionality
    function resetSearch() {
      $(".conditions-and-treatments-listing__intro").show();
      $(".conditions-and-treatments-listing__items").show();
      $(".conditions-and-treatments-item").show();
      document.querySelector(".clear-condition-search").style.opacity = "0";
      conditionDropdown.style.display = "none";
      var items = conditionDropdown.querySelector("ul li");
      if (items.length > 0) {
        items.forEach((item) => {
         item.classList.remove("hidden");
        });
      }
      const noResultsListing = document.querySelector(".no-results-listing");
      if (noResultsListing !== null) {
        noResultsListing.classList.add("hidden");
      }
    }

    // Clear search button functionality
    const clearBtn = document.querySelector(".clear-condition-search");
    if (clearBtn != null) {
      clearBtn.addEventListener("click", function (e) {
        e.preventDefault();
        resetSearch();
        conditionSearchInput.value = "";
      });
    }
  }
})(jQuery);
